var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"item"},[_vm._v(" "+_vm._s(_vm.$G( "破损包赔服务是指消费者在Milky Cloud购买商品时，若消费者在收货时存在包装/商品破损、漏液的情形，并在签收之时起的72小时发起售后申请，且在消费者提供有效凭证的情况下，Milky Cloud有对破损商品对应金额做退款处理的服务。" ))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }